export function getUnfriendlyCountries(state) {
  return state.unfriendlyCountries;
}
